import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import {Container as ContainerBase } from "components/misc/Layouts.js"
import logo from "../../images/odvz_color.png";
import { ReactComponent as FacebookIcon } from "../../images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "../../images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "../../images/youtube-icon.svg";


const Container = tw(ContainerBase)`bg-gray-900 text-gray-100 -mx-8 -mb-8`
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const Row = tw.div`flex items-center justify-center flex-col px-8`

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-96`;

const LinksContainer = tw.div`mt-8 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`
const Link = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4`;

const SocialLinksContainer = tw.div`mt-10`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block text-gray-100 hover:text-gray-500 transition duration-300 mx-4`}
  svg {
    ${tw`w-5 h-5`}
  }
`;

const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-gray-600`
export default () => {
  return (
    <Container id="contacto">
      <Content>
        <Row>
          <LogoContainer>
            <LogoImg src={logo} />
       
          </LogoContainer>
         {/**  <LinksContainer>
            <Link href="#">Home</Link>
            <Link href="#">About</Link>
            <Link href="#">Contact Us</Link>
            <Link href="#">Blog</Link>
            <Link href="#">Reviews</Link>
         </LinksContainer> */}
          <SocialLinksContainer>
            <SocialLink href="#" target="_blank">
              <FacebookIcon />
            </SocialLink>
            <SocialLink href="https://twitter.com/ConsultoresOdvz" target="_blank">
              <TwitterIcon />
            </SocialLink>
            <SocialLink href="#" target="_blank">
              <YoutubeIcon />
            </SocialLink>
        
          </SocialLinksContainer>
          <CopyrightText>
          55 9056 4343<br/>
          BAHÍA SAN CRISTÓBAL 3, OFICINA 126 VERÓNICA ANZÚRES, MIGUEL HIDALGO, C.P. 11300, CIUDAD DE MÉXICO
          </CopyrightText>
        </Row>
      </Content>
    </Container>
  );
};
